import { render, staticRenderFns } from "./Jelovnik.vue?vue&type=template&id=efc7b3da&"
import script from "./Jelovnik.vue?vue&type=script&lang=js&"
export * from "./Jelovnik.vue?vue&type=script&lang=js&"
import style0 from "./Jelovnik.vue?vue&type=style&index=0&id=efc7b3da&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports